/* eslint no-param-reassign: "error" */

export default {
  SET_ALL_COUNTERPARTY_TYPES(state, data) {
    state.counterpartyTypes = data;
  },

  SET_ALL_COUNTERPARTY_ADDRESS_TYPES(state, data) {
    state.counterpartyAddressTypes = data;
    state.availableAddressTypes = data;
  },

  ADD_ADDRESS(state, data) {
    state.addedAdresses.push(data);
  },

  UPDATE_ADDED_ADDRESSES_FOR_EDIT(state, valueArray) {
    state.addedAdresses = valueArray;
  },

  SET_ALL_DIRECTORY_LEGAL_FORMS(state, data) {
    state.directoryLegalForms = data;
  },

  SET_ALL_COUNTERPARTIES(state, data) {
    state.counterparties = data;
    if (data.length > 0) {
      state.currentCounterpartyIdInDB = data[0].idInDB;
    }
  },

  SET_COUNTERPARTIES_FOR_CONTRACT(state, data) {
    state.counterpartiesForContract = data;
  },

  SET_COUNTERPARTIES_HISTORY(state, data) {
    state.counterpartiesHistory = data;
  },

  ADD_COUNTERPARTY(state, data) {
    state.counterparties.unshift(data);
  },

  UPDATE_COUNTERPARTY(state, data) {
    const index = state.counterparties.findIndex(element => element.idInDB === data.idInDB);
    if (index == -1) {
      state.counterparties.push(data);
    } else {
      state.counterparties[index] = data;
    }
  },

  SET_CURRENT_COUNTERPARTY_ID(state, id) {
    state.currentCounterpartyIdInDB = id;
  },

  ADD_SELECTED_ADDRESS_TYPES(state, value) {
    state.selectedAddressTypes.push(value);
  },

  UPDATE_EDITED_ADDED_ADDRESS(state, payload) {
    for (let i = 0; i < state.addedAdresses.length; i++) {
      if (state.addedAdresses[i].addressType === payload.oldAddressType) {
        state.addedAdresses[i].addressType = payload.currentAddressType;
      }
    }
  },

  UPDATE_SELECTED_ADDRESS_TYPES_FOR_EDIT(state, valueArray) {
    let newArray = [];

    for (let i = 0; i < state.counterpartyAddressTypes.length; i++) {
      const element = state.counterpartyAddressTypes[i];
      const isContain = valueArray.some(a => a.addressType === element.addressFullName);
      if(isContain) {
        newArray.push(state.counterpartyAddressTypes[i]);
      }
    }

    state.selectedAddressTypes = newArray;
  },

  REMOVE_SELECTED_ADDRESS_TYPES(state, value) {
    for (let i = 0; i < state.selectedAddressTypes.length; i++) {
      if ( state.selectedAddressTypes[i].addressFullName === value.addressFullName) {
        state.selectedAddressTypes.splice(i, 1);
      }
    }
  },

  CLEAR_SELECTED_ADDRESS_TYPES(state) {
    state.selectedAddressTypes = [];
  },

  CLEAR_ADDED_ADDRESSES(state) {
    state.addedAdresses = [];
  },

  CLEAR_COUNTERPARTIES(state) {
    state.counterparties = [];
  }
};
